import constants from "../Utils/constants";

function DocumentTitle(title) {
  document.title = `${constants.SITE.TITLE}${title ? ` | ${title}` : ""}`;
}

export default DocumentTitle;
